import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#FAF9F9",
    borderRadius: "10px 10px 5px 5px",
  },
  subSection: {
    background: "#fff",
    borderRadius: 10,
    border: "#F5F4F4 solid 1px",
  },
  stats: {
    cursor: "pointer",
    "& span": {
      marginLeft: 5,
      lineHeight: "16px",
      marginRight: 5,
    },
    "& svg": {
      color: "#A0A0A0",
      fontSize: 22,
    },
  },
  dotIndicator: {
    position: "relative",
    "&:before": {
      content: '""',
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#ED7020",
      right: -3,
      top: -1,
      position: "absolute",
    },
  },
  arrowBtn: {
    width: 22,
  },
  average: {
    "& p": {
      color: "#888888",
    },
  },
  peopleList: {
    width: 200,
    padding: "10px 16px",
    "&:first-child": {
      borderRadius: "4px 4px 0 0",
    },
    "&:last-child": {
      marginBottom: 0,
      borderRadius: "0 0 4px 4px",
    },
    "& .MuiAvatar-root": {
      width: 25,
      height: 25,
      fontSize: 12,
    },
  },
  newUser: {
    background: "#FDF3EA",
    border: "solid 1px #E4CBB7",
  },
}));

export default useStyles;
